import { Feature } from "src/app/services/response-models/features.response.model";

export class LoadFeatures {
    public static readonly type = "[Features] Load features";

    constructor(public payload: Feature[]) {}
}

export class ClearFeatures {
    public static readonly type = "[Features] Clear features";

    constructor() {}
}
